export const directionOptions = [
  { text: 'Inbound', value: 'inbound' },
  { text: 'Outbound', value: 'outbound' },
  { text: 'Third party', value: 'third-party' },
]

export const inProcessStatusOptions = [
  { text: 'Quoting', value: 'pending' },
  { text: 'Awarded', value: 'awarded' },
]

export const pricingMethodOptions = [
  { text: 'Capacity', value: 'capacity' },
  { text: 'Contracted', value: 'contracted' },
]

export const pricingTypeOptions = [
  { text: 'Density', value: 'density' },
  { text: 'Pallet', value: 'pallet' },
  { text: 'Spot', value: 'spot' },
  { text: 'Tariff', value: 'tariff' },
]

export const readyCompletedStatusOptions = [
  { text: 'Ready / Scheduled', value: 'confirmed' },
  { text: 'In transit', value: 'picked-up' },
  { text: 'Delivered', value: 'delivered' },
  { text: 'Canceled', value: 'canceled' },
]

export const shippingModeOptions = [
  { text: 'Consolidated', value: 'consolidated' },
  { text: 'Intermodal', value: 'intermodal' },
  { text: 'Less than truckload', value: 'ltl' },
  { text: 'Parcel', value: 'parcel' },
  { text: 'Truckload', value: 'truckload' },
]

export const yesNoOptions = [
  { text: 'Yes', value: 'true' },
  { text: 'No', value: 'false' },
]
